import { DataScienceQuery } from 'dashboard-services/api/dataScience';
import { CommonService } from 'dashboard-services/services';

import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

export default (() => {
  const useGetTaskVersions = ({ getQueryBuilder, taskId, query, size }) =>
    useInfiniteQuery({
      ...DataScienceQuery.QUERIES.getTaskVersions(
        getQueryBuilder,
        {
          taskId,
          query: query || "",
          size
        }
      ),
      enabled: !!taskId,
      initialPageParam: 0,
      getNextPageParam: CommonService.getNextPageParam
    })

  const useGetTaskVersionsMutation = ({ getQueryBuilder, taskId, query, size }) =>
    useMutation({
      ...DataScienceQuery.QUERIES.getTaskVersionsAsMutation(
        getQueryBuilder,
        {
          query,
          size,
          taskId
        }
      )
    })

  const useGetTasks = ({ getQueryBuilder, query, enabled = true }) => 
    useQuery({
      ...DataScienceQuery.QUERIES.searchTasks(
        getQueryBuilder,
        {
          query,
          size: 1000
        }
      ),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
      gcTime: 60 * 60 * 1000, // 1hour,
      staleTime: 60 * 60 * 1000, // 1hour,
    })

  const useCreateTask = ({ getQueryBuilder }) => 
    useMutation({
      ...DataScienceQuery.QUERIES.createTask(
        getQueryBuilder
      )
    })

  const useUpdateTask = ({ getQueryBuilder }) => 
    useMutation({
      ...DataScienceQuery.QUERIES.updateTask(
        getQueryBuilder
      )
    })
 
  const useSearchTasks = ({ getQueryBuilder, query, sortBy, sortOrder, shouldBeLimited, onSelect, size = CommonService.MIN_REQUEST_SIZE, shouldRefetch = true, ...rest }) => 
    useInfiniteQuery({
      ...DataScienceQuery.QUERIES.searchTasks(
        getQueryBuilder,
        {
          query,
          size,
          sortBy,
          sortOrder
        }
      ),
      initialPageParam: 0,
      refetchInterval: () => !shouldRefetch || shouldBeLimited() ? undefined : 10_000,
      getNextPageParam: CommonService.getNextPageParam,
      select: onSelect,
      ...rest
    })
  
  const useSearchTasksMutation = ({ getQueryBuilder, query, sortBy, sortOrder, size = 1, ...rest }) =>
    useMutation({
      ...DataScienceQuery.QUERIES.searchTasksMutation(
        getQueryBuilder,
        {
          query,
          sortBy,
          sortOrder,
          size
        }
      ),
      ...rest
    })

  const useExecuteTask = ({ getQueryBuilder, taskName, taskVersion, taskGroupName, params, withOpenAiKey, ...rest }) =>
    useMutation({
      ...DataScienceQuery.QUERIES.executeTask(
        getQueryBuilder,
        {
          taskName,
          taskVersion,
          taskGroupName,
          params,
          withOpenAiKey
        }
      ),
      ...rest
    })

  return {
    useGetTaskVersions,
    useGetTaskVersionsMutation,
    useGetTasks,
    useUpdateTask,
    useCreateTask,
    useSearchTasks,
    useSearchTasksMutation,
    useExecuteTask
  }
})()